var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h5", { staticClass: "mb-3" }, [
        _vm._v("\n    " + _vm._s(_vm.dataComponent.name) + "\n  ")
      ]),
      _vm._v(" "),
      _c("img", {
        staticStyle: { width: "100%" },
        attrs: { src: require("@/assets/new-form-ui/map-dummy.png") }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "tabs mt-4" },
        _vm._l(_vm.tabs, function(tab, index) {
          return _c(
            "div",
            {
              key: tab,
              staticClass: "tab-list",
              class: { "tab-active": index === 0 }
            },
            [_vm._v("\n      " + _vm._s(tab) + "\n    ")]
          )
        })
      ),
      _vm._v(" "),
      _c(
        "b-button",
        {
          staticClass: "btn grey btn-import-form mt-3",
          attrs: { disabled: "" }
        },
        [_c("i", { staticClass: "fa fa-search fa-lg" }), _vm._v(" Search\n  ")]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "columns mt-3" }, [
        _c(
          "div",
          { staticClass: "d-flex align-items-center" },
          _vm._l(_vm.columns, function(column) {
            return _c(
              "div",
              { key: column, staticClass: "column" },
              [
                _c(
                  "div",
                  {
                    staticClass: "header-list",
                    staticStyle: { cursor: "default !important" }
                  },
                  [
                    _c("div", { staticClass: "column-name" }, [
                      _vm._v(_vm._s(column))
                    ])
                  ]
                ),
                _vm._v(" "),
                _vm._l(4, function(index) {
                  return _c(
                    "div",
                    {
                      key: index,
                      staticClass: "column-preview",
                      class: { "bg-gray": index === 2 || index === 4 },
                      staticStyle: { cursor: "default !important" }
                    },
                    [_c("div", { staticClass: "content-preview" })]
                  )
                })
              ],
              2
            )
          })
        )
      ])
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-37982fe0", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-37982fe0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dummy/DummyAttendanceMonitor.vue
// module id = null
// module chunks = 